import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BreadCrumbsGeneric from "../../../components/Nav/BreadCrumbsGeneric";
import { ArrowSmUpIcon } from "@heroicons/react/solid";
import { UseContextApp } from "../../../Global/Context/appContext";
import banner from "../../../assets/Banners/banner_salud_integral_cuadrado.jpg";
import { colors } from "../../../propsType/Colors";
import { TabNavegation } from "../../../propsType/TabNavegation";
import medios from "../../../assets/Banners/banner_salud_integral_largo.jpg";
import descargaContrato from "../../../assets/svg/descargar_contrato.svg";
import contrasena from "../../../assets/svg/contrasena.svg";
import '../../css/streaming.css';

function DetailsSaludIntegral() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  const [deatils, setDeatils] = useState(null);
  const [detailsAll, setDeatilsAll] = useState(null);
  const [{ user }] = UseContextApp();
  const stats = [
    {
      name: "Número de Cuenta",
      stat: deatils?.cuenta,
      previousStat: "",
      change: "",
      changeType: "",
    },    
    {
      name: "Número de Contrato",
      stat: deatils?.contrato,
      previousStat: "",
      change: "",
      changeType: "",
    },
    {
      name: "Estatus",
      // stat: user?.datos?.maskEmail,
      stat: deatils?.status,
      previousStat: "",
      change: "",
      changeType: "increase",
    },
  ];
  const { tabsHogarDetails, tabsEmpresaDetails } = TabNavegation(pathName)
  const [tabs, setTabs] = useState(user?.datos?.tipoCliente === 'Hogar' ? tabsHogarDetails : tabsEmpresaDetails || [''])
  useEffect(() => {
    setDeatils(location?.state?.data);
    setDeatilsAll(location?.state?.dataAll);
  }, [location.state]);

  useEffect(() => {

  }, [deatils]);
  

  function handleChangeRoute(e) {
    let route = e.target.value;
    switch (route) {
      case "Servicios Internet":
        navigate("/cuenta/servicio-de-internet");
        break;
      case "Servicios Televisión":
        navigate("/cuenta/servicio-de-television");
        break;
      case "Servicios Televisión Streaming":
        navigate("/cuenta/servicio-de-streaming");
        break;
      case "Servicios Telefonía":
        navigate("/cuenta/servicio-de-telefonia");
        break;
      case "Servicios Salud Integral":
        navigate("/cuenta/servicio-de-salud-integral");
        break;
      default:
        break;
    }
  }
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const handleRedirectMessage = (e, message) => {
    e.preventDefault();

    // Obtener la URL actual y agregar el parámetro `send_message`
    const currentPath = location.pathname;
    const newUrl = `${currentPath}?send_message=${message}`;

    // Navegar a la misma página con el parámetro añadido en la URL
    navigate(newUrl, { state: { ...location.state }, replace: true });

    // Recargar el componente sin perder `location.state`
    setTimeout(() => {
      navigate(0);
    }, 100);
  };

  const handleRedirectContrasena = (e) => {
    e.preventDefault();

    const url = "/cuenta/servicio-de-salud-integral/detalle-salud-integral?send_message=actualizar%20datos";

    navigate(url);

    window.location.href = url

  }

  const handleRedirectEmail = (e) => {
    e.preventDefault();

    const url = "/cuenta/servicio-de-salud-integral/detalle-salud-integral?send_message=actualizar%20datos";

    navigate(url);

    window.location.href = url

  }

  return (

    <>
      <div className=" relative bg-[#f3f4f6]">
        <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
          <div className="flex lg:w-full gap-5 p-[20px] lg:p-2 overflow-auto flex-col">
            {/*   Recibe la navegacion y actualiza que te indica en que ruta estas */}
            <BreadCrumbsGeneric locations={pathName} />
            <div>
              <div>
                <div className="sm:hidden">
                  <label htmlFor="tabs" className="sr-only">
                    Select a tab
                  </label>
                  <select
                    id="tabs"
                    name="tabs"
                    onChange={handleChangeRoute}
                    className="block w-full h-11 p-[10px] shadow focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                    defaultValue={tabs.find((tab) => tab.current).name}
                  >
                    {tabs.map((tab) => (
                      <option key={tab.name}>{tab.name}</option>
                    ))}
                  </select>
                </div>
                <div className="hidden sm:block">
                  <nav
                    className="relative z-0 rounded-lg shadow flex divide-x divide-gray-200"
                    aria-label="Tabs"
                  >
                    {tabs.map((tab, tabIdx) => (
                      <Link
                        key={tab.name}
                        to={tab.href}
                        className={classNames(
                          tab.current
                            ? "text-gray-900"
                            : "text-gray-500 hover:text-gray-700",
                          tabIdx === 0 ? "rounded-l-lg" : "",
                          tabIdx === tabs.length - 1 ? "rounded-r-lg" : "",
                          "group relative min-w-0 flex-1 overflow-hidden bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10"
                        )}
                        aria-current={tab.current ? "page" : undefined}
                      >
                        <span>{tab.name}</span>
                        <span
                          aria-hidden="true"
                          className={classNames(
                            tab.current
                              ? `bg-[${colors.lightBlue}]`
                              : "bg-transparent",
                            "absolute inset-x-0 bottom-0 h-0.5"
                          )}
                        />
                      </Link>
                    ))}
                  </nav>
                </div>
              </div>
            </div>
            <div>
              <dl className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
                {stats.map((item, index) => (
                  <div
                    key={item.name}
                    className="px-4 flex justify-between items-center py-5 sm:p-6"
                  >
                    <div>
                      <dt className="text-base flex justify-between items-center font-normal text-gray-900 ">
                        {<>{item.name}</>}
                      </dt>
                      <dd className="mt-1 flex justify-between items-center md:block lg:flex">
                        {
                          item.name === 'Estatus' ? (
                            <>
                              <div
                                className={classNames(
                                  item.changeType === "increase" &&
                                  "bg-green-100 text-green-800",
                                  "inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0"
                                )}
                              >
                                {item.changeType === "increase" && (
                                  <ArrowSmUpIcon
                                    className="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500"
                                    aria-hidden="true"
                                  />
                                )}
                                <span className="sr-only">
                                  {item.changeType === "increase"
                                    ? "Increased"
                                    : "Decreased"}
                                  by
                                </span>
                                {item.stat ?? "-"}
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                className={`flex items-baseline text-2xl font-semibold text-[${colors.lightBlue}] `}
                              >
                                {item.stat ?? "-"}
                                <span className="ml-2 text-sm font-medium text-gray-500">
                                  {" "}
                                  {item.previousStat}
                                </span>
                              </div>
                            </>
                          )
                        }
                      </dd>
                    </div>
                  </div>
                ))}
              </dl>
            </div>
            <div>
              <main>
                <div className=" max-w-3xl mx-auto grid grid-cols-1 gap-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-5">
                  <div className="space-y-6 lg:col-start-1 lg:col-span-3">
                    <section aria-labelledby="applicant-information-title">
                      <div className="bg-white shadow h-full sm:rounded-lg">
                        <div className="px-4 py-5 sm:px-6">
                          <h2
                            id="applicant-information-title"
                            className="text-lg leading-6 font-medium text-gray-900"
                          >
                            Detalles de Servicio
                          </h2>
                          <p className="mt-1 max-w-2xl text-sm text-gray-500">
                            Servicios de Salud Integral
                          </p>
                        </div>
                        <div className="border-t border-gray-200 px-4 h-full py-5 sm:px-6 ">
                          <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                            <div className="sm:col-span-1">
                              <dt className="text-sm font-medium text-gray-500">
                                Titular
                              </dt>
                              <dd className="mt-1 text-sm text-gray-900">
                                {user?.datos?.nombreApellido}{" "}
                              </dd>
                            </div>
                            <div className="sm:col-span-1">
                              <dt className="text-sm font-medium text-gray-500">
                                Paquete
                              </dt>
                              <dd className="mt-1 text-sm text-gray-900">
                                {deatils?.paquete}{" "}
                              </dd>
                            </div>
                            <div className="sm:col-span-1">
                              <dt className="text-sm font-medium text-gray-500">
                                Beneficiarios
                              </dt>

                              {detailsAll && detailsAll.length > 0 ? (
                                <dd className="mt-1 text-sm text-gray-900">
                                  {detailsAll?.filter((beneficiario) => beneficiario.paquete === "Beneficiario Adicional")
                                  .map((beneficiario, index) => (
                                    <div key={index}>
                                      {beneficiario.NombreAseg}
                                    </div>
                                  ))}
                                </dd>
                              ) : (
                                <dd className="mt-1 text-sm text-gray-900">No hay beneficiarios adicionales</dd>
                              )}
                            </div>
                            <div className="sm:col-span-1">
                              <dt className="text-sm font-medium text-gray-500">
                                Ciudad
                              </dt>
                              <dd className="mt-1 text-sm text-gray-900">
                                {deatils?.ciudad}{" "}
                              </dd>
                            </div>                            
                          </dl>
                        </div>
                        <div className="container-button-streming flex sm:rounded-b-lg  justify-around items-center" style={{ backgroundColor: colors.lightBlue, padding: '6px', fontSize: '70%' }}>
                          <div>
                            <Link
                              onClick={(e) => handleRedirectMessage(e, 'copia%20de%20contrato')}
                              className={`flex justify-center items-center block bg-[${colors.lightBlue}] text-md font-medium hover:bg-[${colors.darkBlue}] duration-300 easy hover:text-white text-white text-center px-2 py-2  sm:rounded-lg shadow-lg  border-2 border-[${colors.darkBlue}]`}
                            >
                              <img className="w-[20px] mr-[4px]" src={descargaContrato} alt="" />
                              Descargar contrato
                            </Link>
                          </div>
                          <div>
                            <Link
                              onClick={(e) => handleRedirectMessage(e, 'cambio%20de%20beneficiario')}
                              className={`flex justify-center items-center block bg-[${colors.lightBlue}] text-md font-medium hover:bg-[${colors.darkBlue}] duration-300 easy hover:text-white text-white text-center px-2 py-2  sm:rounded-lg shadow-lg  border-2 border-[${colors.darkBlue}]`}
                            >
                              <img className="w-[20px] mr-[4px]" src={descargaContrato} alt="" />
                              Cambio de beneficiario
                            </Link>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div className="lg:col-span-2">
                    <img
                      className="w-full  cover rounded-[10px] h-[381px] shadow-lg"
                      src={banner}
                      alt=""
                    />
                  </div>
                </div>
              </main>
            </div>
            <img className="w-full h-full rounded-t-lg" src={medios} alt="" />
          </div>
        </div>
      </div>
    </>
  );
}

export default DetailsSaludIntegral;
